import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { detailData } from '../config.js';
import { exportWelfareFund } from '@/api/payroll/welfare-fund';
export default {
  data: function data() {
    return {
      form: {
        month: '',
        page: 1,
        limit: 100
      },
      pageSizes: [20, 50, 100],
      pageData: {},
      tableData: [],
      tableColumns: JSON.parse(JSON.stringify(detailData[5].table || [])),
      exportLoading: false,
      loading: false,
      listRequestId: 0
    };
  },
  computed: {
    tipText: function tipText() {
      return detailData[5].selectData && detailData[5].selectData.text || [];
    }
  },
  methods: {
    // 月份改变
    handleMonthChange: function handleMonthChange() {
      this.form.page = 1;
      this.tableData = [];
      this.pageData = {};
      if (this.form.month) {
        this.search(1);
        return;
      }
      this.listRequestId += 1;
      this.loading = false;
    },
    // 搜索
    search: function search(page) {
      var _this = this;
      if (!this.form.month) return;
      if (page) this.form.page = page;
      var requestId = ++this.listRequestId;
      this.loading = true;
      detailData[5].api.apiList({
        month: this.form.month,
        page: this.form.page,
        limit: this.form.limit
      }).then(function (res) {
        if (requestId !== _this.listRequestId) return;
        if (res && res.code === 1) {
          var header = res.data.header || {};
          _this.tableColumns.forEach(function (item) {
            if (header[item.prop]) item.label = header[item.prop];
          });
          _this.tableData = res.data.body || [];
          _this.pageData = res.data.page_data || {};
        } else {
          _this.tableData = [];
          _this.pageData = {};
        }
      }).catch(function () {
        if (requestId !== _this.listRequestId) return;
        _this.tableData = [];
        _this.pageData = {};
      }).finally(function () {
        if (requestId !== _this.listRequestId) return;
        _this.loading = false;
      });
    },
    // 分页改变
    currentChangeHandle: function currentChangeHandle(page) {
      this.form.page = page;
      this.search();
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(size) {
      this.form.limit = size;
      this.search(1);
    },
    // 导出福利基金缴纳文件
    handleExport: function handleExport() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this2.form.month || _this2.exportLoading)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _this2.exportLoading = true;
              _context.prev = 3;
              _context.next = 6;
              return exportWelfareFund({
                month: _this2.form.month,
                form_type: '3'
              });
            case 6:
              res = _context.sent;
              if (res && res.code === 1) {
                _this2.$message.success(res.message);
                if (res.data.object_url) window.location.href = res.data.object_url;
              }
            case 8:
              _context.prev = 8;
              _this2.exportLoading = false;
              return _context.finish(8);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3,, 8, 11]]);
      }))();
    }
  }
};